/* English Path — utilidades propias del tema (código propio). */
(function () {
  const EP = (window.EP = window.EP || {});

  function cartDrawer() {
    return document.querySelector('cart-drawer');
  }

  // Añade un producto al carrito y refresca el carrito lateral de Dawn.
  EP.addToCart = function (variantId, quantity, button) {
    if (!variantId) return Promise.resolve();
    const drawer = cartDrawer();
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    }
    const body = {
      items: [{ id: Number(variantId), quantity: Number(quantity) || 1 }],
    };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
    }
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then((r) => r.json())
      .then((state) => {
        if (state.status) {
          alertFallback(state.description || state.message);
          return;
        }
        if (drawer && state.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ id: variantId, sections: state.sections });
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch(() => {
        window.location = window.routes.cart_url;
      })
      .finally(() => {
        if (button) {
          button.removeAttribute('aria-disabled');
          button.classList.remove('loading');
        }
      });
  };

  function alertFallback(message) {
    const box = document.querySelector('.ep-toast') || document.createElement('div');
    box.className = 'ep-toast';
    box.textContent = message || 'No se ha podido añadir el producto.';
    document.body.appendChild(box);
    setTimeout(() => box.remove(), 3500);
  }

  // Botones "Añadir" de upsells (carrito y ficha de producto).
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-ep-add]');
    if (!button) return;
    event.preventDefault();
    EP.addToCart(button.dataset.epAdd, button.dataset.epQty || 1, button);
  });

  // Barra fija de compra en la ficha de producto.
  function initSticky() {
    const bar = document.querySelector('[data-ep-sticky]');
    if (!bar) return;
    const sectionId = bar.dataset.section;
    const anchor =
      document.querySelector('#ProductSubmitButton-' + sectionId) ||
      document.querySelector('product-form button[type="submit"]');
    if (!anchor || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', passed);
          bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      },
      { threshold: 0 }
    );
    observer.observe(anchor);

    bar.querySelector('[data-ep-sticky-buy]')?.addEventListener('click', (event) => {
      event.preventDefault();
      const form = document.querySelector('#product-form-' + sectionId);
      const idInput = form && form.querySelector('[name="id"]');
      const qtyInput = document.querySelector('#Quantity-' + sectionId);
      EP.addToCart(idInput ? idInput.value : bar.dataset.variant, qtyInput ? qtyInput.value : 1, event.currentTarget);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSticky);
  } else {
    initSticky();
  }
})();
